import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../../context';
import { getStore } from '../../../utils/queries';
import ViewStoreButton from './ViewStoreButton';

export default function StoreSettingsPage({ title, children }) {
	const { activeStoreId } = useContext(MyContext);
	const [store, setStore] = useState(null);
	const [loading, setLoading] = useState(true);
	// A DOM node children can portal page-header actions (buttons, etc.) into,
	// so they render inline with the title instead of the tab needing to
	// duplicate its own header row. useState (not a plain ref) so setting it
	// triggers the re-render children need to see a non-null node to portal into.
	const [headerActionsEl, setHeaderActionsEl] = useState(null);

	useEffect(() => {
		if (!activeStoreId) {
			setLoading(false);
			return;
		}
		setLoading(true);
		getStore(activeStoreId).then((result) => {
			if (result?.success) setStore(result.data);
			setLoading(false);
		});
	}, [activeStoreId]);

	if (loading) {
		return <div className='py-8 pr-8 text-sm text-gray-400'>Loading...</div>;
	}

	if (!store) {
		return (
			<div className='py-8 pr-8'>
				<p className='text-sm text-gray-500'>No store selected.</p>
			</div>
		);
	}

	return (
		<div className='py-8 pr-8'>
			<div className='flex items-center justify-between gap-6 mb-6'>
				<h1 className='text-2xl font-light tracking-tight'>{title}</h1>
				<div className='flex items-center gap-2 shrink-0'>
					<div ref={setHeaderActionsEl} className='flex items-center gap-2' />
					<ViewStoreButton store={store} />
				</div>
			</div>
			{children(store, setStore, headerActionsEl)}
		</div>
	);
}
